//112022 para mision extra hermanas
export const lugarMision = [
  "", "Obra STJ", "Proyecto STJ", "Otro"
];
export const nivelMision = [
  "","No aplicable", "Adolescentes (J1, J2 y J3)", "Jóvenes (18 a 30 años)", "Adultos ( más de 30)"
];

export const workCategories = ["Alojamiento", "CasaEspiritualidad", "Educativo", "Sanitario", "Social"];
export const context = { 1: "Urbano-residencial", 2: "Urbano-medio", 3: "Urbano-marginal", 4: "Rural", 5: "Rural-marginal" };
export const juridicPersonality = ["Asociación civil sin fines de lucro", "Congregación", "Fundación católica", "Fundación civil", "Sociedad civil", "Otra"];
export const juridicProperty = ["Fe y Alegría", "Intercongregacional", "Parroquia o Diocesis", "STJ", "Otra"];
export const tiposEducacionObra = {
  EdInfantilI: "Educación infantil I",
  EdInfantilII: "Educación infantil II",
  EdPrimaria: "Educación primaria",
  EdSecundaria: "Educación secundaria",
  Bach: "Bachillerato/preparatoria",
  Universidad: "Universidad",
};

export const ingresosObras = [
  "Alquiler de espacios",
  "Actividades extraescolares",
  "Aportación por actividades",
  "Colegiatura/mensualidad",
  "Hospedaje",
  "Matrícula",
  "Servicios",
  "Servicios médicos",
  "Venta farmacia",
  "Venta material escolar",
  "Otros",
];
export const ingresosObraEducativa = ["Alquiler de espacios", "Actividades extraescolares", "Colegiatura/mensualidad", "Matrícula", "Servicios", "Venta material escolar"];
export const ingresosObraAlojamiento = ["Alquiler de espacios", "Matrícula", "Mensualidad", "Otros"];
export const ingresosObraSanitario = ["Servicios médicos", "Venta Farmacia", "Otros"];
export const ingresosObraEspiritualidad = ["Hospedaje", "Otros"];
export const ingresosObraSocial = ["Alquiler de espacios", "Aportación por actividades", "Otros"];
export const personasAtendidas = ["0-5", "6-11", "12-15", "16-18", "19-25", "26-60", "60+"];
export const personasAtendidasObj = {
  "0-5": "Niños de 0-5 años",
  "6-11": "Niños de 6-11 años",
  "12-15": "Adolescentes (12-15 años)",
  "16-18": "Jóvenes (16-18 años)",
  "19-25": "Jóvenes (19-25 años)",
  "26-60": "Adultos (26-60 años)",
  "60+": "Adultos (>60 años)",
};

// *********************************************************** HERMANAS *******************************************************

// Situaciones particulares
export const tipoSituacionesParticularesObj = {
  Exclaustracion: "Exclaustración",
  PasoInstituto: "Paso a otro instituto",
  PermisoAusencia: "Permiso de ausencia",
  Reingreso: "Reingreso",
  Secularizacion: "Secularización",
};
export const entiendadesOtorgadorasExclaustracion = { CIVCSVA: "CIVCSVA", CoordinadoraGeneral: "Coordinadora general" };
export const entiendadesOtorgadorasPermisoAusencia = { CoordinadoraProvincial: "Coordinadora provincial", ...entiendadesOtorgadorasExclaustracion };
// Niveles grupos de trabajo
export const levelTeams = ["Continental", "General"];

// *********************************************************** MISIONES *******************************************************
export const tipoMisiones = { Obra: "Obra", Proyecto: "Proyecto" };

// *********************************************************** OBRAS **********************************************************
export const tiposObras = {
  Alojamiento: "Residencias, internados, centro de formación femenina",
  CasaEspiritualidad: "Casa de espiritualidad, oración",
  Educativo: "Escuela, colegio, universidad",
  Sanitario: "Hospital, dispensario, centro de salud",
  Social: "Centro comunitario, club del niño, centro social",
};
// *********************************************************** EN COLABORACIÓN *************************************************
export const tiposEnColaboracion = { OrgEcle: "Organismo eclesiástico", SemDio: "Seminario Diocesano" };

// ********************************************************* PROYECTOS *********************************************************
export const tiposProyectos = {
  Espiritualidad: "Espiritualidad",
  MujerSociedad: "Mujer y sociedad",
  Pueblos: "Pueblos originarios, afrodescendientes y campesinos",
  Salud: "Salud o socio asistencial",
  ServicioEclesial: "Servicios eclesiales",
  Socioeducativo: "Socioeducativo",
};

// ********************************************************* CATEGORIAS *********************************************************

export const categoriaMisiones = { ...tiposEnColaboracion, ...tiposObras, ...tiposProyectos };

// ********************************************************* ACTIVIDADES ********************************************************
export const actividadesObraSocial = {
  ApoyoEscolar: "Apoyo/refuerzo escolar",
  EducacionTiempoLibre: "Educación tiempo libre",
  FormacionLideres: "Formación de líderes",
  FormacionMujer: "Formación de la mujer",
  Otra: "Otra",
};
export const actividadesProyectoSociedad = {
  DefensaDerechos: "Defensa de derechos",
  Emprendimiento: "Emprendimiento",
  Formacion: "Formación",
  Liderazgo: "Liderazgo",
  Promocion: "Promoción",
  Otra: "Otra",
};
export const actividadesProyectoEspiritualidad = {
  AcompañamientoPsicoEspiritual: "Acompañamiento psico-espiritual",
  CursoOnline: "Cursos online",
  Formacion: "Formación",
  InvestigacionFuentes: "Investigación de las fuentes",
  Liderazgo: "Liderazgo",
  MagisterioOracion: "Magisterio oración",
  Otra: "Otra",
};
export const actividadesProyectoSocioeducativo = {
  AtencionAdultoMayor: "Atención al Adulto mayor",
  AtencionInfancia: "Atención a infancia",
  AtencionPsicologica: "Atención psicológica",
  AtencionSocioAsistencial: "Atención socio-asistencial",
  Comedor: "Comedor",
  DefensaDerechosHumanos: "Defensa derechos humanos",
  FormacionLideres: "Formación de líderes",
  FormacionValores: "Formación en valores",
  TiempoLibre: "Tiempo libre",
  Otra: "Otra",
};
export const actividadesProyectoSalud = {
  AtencionPrimaria: "Atención primaria",
  AtencionPsicologica: "Atención psicológica",
  Farmacia: "Farmacia",
  Formacion: "Formación",
  MedicinaAlternativa: "Medicina alternativa",
  Otra: "Otra",
};
export const actividadesProyectoEclesiales = {
  Castequesis: "Catequesis",
  ConferenciasReligiosas: "Conferencia de religiosas",
  Diocesis: "Diócesis",
  FormacionAdultos: "Formación adultos",
  GruposFe: "Grupos de fe",
  MinisterioEclesiales: "Ministerios eclesiales",
  PastoralComunitaria: "Pastoral comunitaria",
  PastoralMigrantes: "Pastoral con migrantes",
  PastoralParticipacionCaritas: "Pastoral o participación en Cáritas",
  PastoralPenitenciaria: "Pastoral penitenciaria",
  Otra: "Otra",
};
export const actividadesProyectoNativo = {
  CuidadoSemillas: "Cuidado de las semillas",
  FormacionLideres: "Formación de líderes",
  MedicinaAlternativa: "Medicina alternativa",
  PastoralInculturada: "Pastoral inculturada",
  TalleresDeFormacion: "Talleres de formación",
  Otra: "Otra",
};

export const actividades = {
  Espiritualidad: actividadesProyectoEspiritualidad,
  MujerSociedad: actividadesProyectoSociedad,
  Pueblos: actividadesProyectoNativo,
  Salud: actividadesProyectoSalud,
  Social: actividadesObraSocial,
  ServicioEclesial: actividadesProyectoEclesiales,
  Socioeducativo: actividadesProyectoSocioeducativo,
};

// ********************************************************* AMBITOS *******************************************************
export const ambitosObras = {
  Escolar: "Escolar",
  Espiritualidad: "Espiritualidad",
  MujerSociedad: "Mujer y sociedad",
  PJVT: "Pastoral Juvenil Vocacional Teresiana (PJVT)",
  Pueblos: "Pueblos originarios, campesinos y afrodescendientes",
  Salud: "Salud",
  ServiciosEclesialesParroquial: "Servicios eclesiales o Parroquial",
  SocialSocioeducativo: "Social o Socioeducativo",
  Otro: "Otro",
};
export const ambitosObraSocial = { ...ambitosObras };
export const ambitosObraEducativa = { ...ambitosObras };
export const ambitosObraAlojamiento = { ...ambitosObras };
export const ambitosObraSanitario = { ...ambitosObras };
export const ambitosObraEspiritualidad = { ...ambitosObras };

export const ambitos = {
  Alojamiento: ambitosObraAlojamiento,
  CasaEspiritualidad: ambitosObraEspiritualidad,
  Educativo: ambitosObraEducativa,
  Sanitario: ambitosObraSanitario,
  Social: ambitosObraSocial,
};

// ********************************************************* PERSONAL ******************************************************

export const personalObraEducativa = { Educador: "Educadores", PAdministrativo: "Personal Administración", PMantenimiento: "Personal de Mantenimiento" };
export const personalObraAlojamiento = { ...personalObraEducativa };
export const personalObraSanitario = { Auxiliar: "Auxiliares", Enfermero: "Enfermeros", Medico: "Médicos", PAdministrativo: "Personal Administración", PMantenimiento: "Personal de Mantenimiento" };
export const personalObraEspiritualidad = { PAdministrativo: "Personal Administración", PServicio: "Personal de Servicios", Otros: "Otros" };
export const personalObraSocial = { Educador: "Educadores", PAdministrativo: "Personal Administración", PMantenimiento: "Personal de Mantenimiento", TrabajadorSocial: "Trabajadores sociales" };

//102022
//"Educativo", "Alojamiento", "Sanitario", "CasaEspiritualidad", "Social"
export const personal = {
  Alojamiento: personalObraAlojamiento,
  CasaEspiritualidad: personalObraEspiritualidad,
  Educativo: personalObraEducativa,
  Sanitario: personalObraSanitario,
  Social: personalObraSocial,
};
// Todo
// ********************************************************* INGRESOS ******************************************************

// ********************************************************* COMUNIDAD ******************************************************
export const participacionCon = {
  AsociacionesCiviles: "Asociaciones Civiles",
  AsociacionesReligiosas: "Asociaciones Religiosas",
  AsociacionesVecinales: "Asociaciones Vecinales",
  ONGD: "ONGD",
  OtrasCongregaciones: "Otras Congregaciones",
};

export const vinculacionCon = {
  AsociacionesCiviles: "Asociaciones Civiles",
  AsociacionesReligiosas: "Asociaciones Religiosas",
  AsociacionesVecinales: "Asociaciones Vecinales",
  Diócesis: "Diócesis",
  ONGD: "ONGD",
  OtrasCongregaciones: "Otras Congregaciones",
  Parroquia: "Parroquia",
  Otros: "Otros",

};

// ********************************************************* CARGOS ************************************************
// Provincia
export const cargosGobiernoProvincial = {
  ConsejeraEducacion: "Consejera delegada de educación",
  ConsejeraEnfermerias: "Consejera delegada de enfermerías",
  Consejeraormacion: "Consejera delegada de formación",
  ConsejeraPais: "Consejera delegada de país",
  ConsejeraPais2: "Consejera delegada de país 2",
  Consejera2: "Consejera provincial 2",
  Consejera3: "Consejera provincial 3",
  Consejera4: "Consejera provincial 4",
  Consejera5: "Consejera provincial 5",
  Consejera6: "Consejera provincial 6",
  Coordinadora: "Coordinadora provincial",
  Vicaria: "Vicaria provincial",
};

export const cargosOficiosProvinciales = {
  DelegadaEducacion: "Delegada de educación provincial",
  DelegadaFormacion: "Delegada de formación provincial",
  Economa: "Ecónoma provincial",
  FormadoraNovicias: "Formadora de novicias",
  ResponsableJunioras: "Responsable de junioras",
  ResponsablePrenovicias: "Responsable prenovicias provincial",
  Secretaria: "Secretaria provincial",
};

export const cargosOtrosServiciosProvinciales = {
  AuxiliarEconomia: "Ecónoma auxiliar provincial",
  AuxiliarSecretaria: "Secretaria auxiliar provincial",
  ResponsableComunicacion: "Responsable de comunicación provincial",
};

export const cargosServiciosProvinciales = {
  AuxiliarEconomia: "Ecónoma auxiliar provincial",
  AuxiliarSecretaria: "Secretaria auxiliar provincial",
  Consejera2: "Consejera provincial 2",
  Consejera3: "Consejera provincial 3",
  Consejera4: "Consejera provincial 4",
  Consejera5: "Consejera provincial 5",
  Consejera6: "Consejera provincial 6",
  Coordinadora: "Coordinadora provincial",
  DelegadaEducacion: "Delegada de educación provincial",
  DelegadaFormacion: "Delegada de formación provincial",
  Economa: "Ecónoma provincial",
  RepresentanteLegal: "Representante legal",
  ResponsablePrenovicias: "Responsable prenovicias provincial",
  ResponsableComunicacion: "Responsable de comunicación provincial",
  Secretaria: "Secretaria provincial",
  Vicaria: "Vicaria provincial",
};

// Dirección general
export const cargosGobiernoGeneral = {
  Coordinadora: "Coordinadora general",
  Vicaria: "Vicaria general",
  Consejera2: "Consejera general 2",
  Consejera3: "Consejera general 3",
  Consejera4: "Consejera general 4",
};
export const cargosOficiosGenerales = {
  DelegadaEducacion: "Delegada de educación general",
  DelegadaFormacion: "Delegada de formación general",
  Economa: "Ecónoma general",
  Secretaria: "Secretaria general"
};
export const cargosOtrosServiciosGenerales = {
  AuxiliarEconomia: "Ecónoma auxiliar general",
  AuxiliarSecretaria: "Secretaria auxiliar general",
  DelegadaMTA: "Delegada general MTA",
  FormadorasContinentales: "Formadora continental",
  ResponsableComunicacion: "Responsable de comunicación general",
  ResponsableTER: "Responsable TER general",
};

export const cargosDireccionGeneral = {
  AuxiliarEconomia: "Ecónoma auxiliar general",
  AuxiliarSecretaria: "Secretaria auxiliar general",
  Consejera2: "Consejera general 2",
  Consejera3: "Consejera general 3",
  Consejera4: "Consejera general 4",
  Coordinadora: "Coordinadora general",
  DelegadaEducacion: "Delegada de educación general",
  DelegadaFormacion: "Delegada de formación general",
  Economa: "Ecónoma general",
  FormadorasContinentales: "Formadora continental",
  ResponsableComunicacion: "Responsable de comunicación general",
  RepresentanteLegal: "Representante legal",
  ResponsableTER: "Responsable TER general",
  Secretaria: "Secretaria general",
  Vicaria: "Vicaria general",
};

// Comunidad
export const cargosServiciosComunitarios = {
  Consejera: "Consejera local",
  Coordinadora: "Coordinadora local",
  Economa: "Economa local",
  Responsable: "Responsable local",
  Secretaria: "Secretaria local",
  Vicaria: "Vicaria local",
};

// Equipos
export const cargosEquiposComisiones = {
  Coordinador: "Coordinador del equipo",
  Miembro: "Miembro del equipo",
};

// Misiones equipos directivos
export const cargosEquiposDirectivosEducativo = {
  DirectorAdministrativo: "Director administrativo",
  DirectorGeneral: "Director general",
  DirectorPastoral: "Director pastoral",
  DirectorPedagogico: "Director pedagógico",
};

export const cargosEquiposDirectivosAlojamiento = {
  DirectorAdministrativo: "Director administrativo",
  DirectorGeneral: "Director general",
};

export const cargosEquiposDirectivosSalud = {
  DirectorAdministrativo: "Director administrativo",
  DirectorGeneral: "Director general",
};

export const cargosEquiposDirectivosEspiritualidad = {
  DirectorAdministrativo: "Director administrativo",
  DirectorGeneral: "Director general",
  DirectorPastoral: "Director pastoral",
  DIrectorPedagogico: "Director pedagógico",
};

export const cargosEquiposDirectivosSocial = {
  DirectorAdministrativo: "Director administrativo",
  DirectorGeneral: "Director general",
};

export const cargosEquiposDirectivos = {
  DirectorAdministrativo: "Director administrativo",
  DirectorGeneral: "Director general",
  DirectorPastoral: "Director pastoral",
  DirectorPedagogico: "Director pedagógico",
  RepresentanteLegal: "Representante legal",
};

export const cargosHermanasQueTrabajanObraOProyecto = {
    Acompañamiento: 'Acompañamiento',
    Docencia: 'Docencia',
    EducadoraSocial: 'Educadora Social',
    Enfermería: 'Enfermería',
    EquipoDeComunicación: 'Equipo de comunicación',
    EquipoDeInnovacion: 'Equipo de innovación',
    EquipoDePastoral: 'Equipo de pastoral',
    Formadora: 'Formadora',
    Mantenimiento: 'Mantenimiento',
    Medico: 'Médico',
    Orientacion: 'Orientación',
    Psicologia: 'Psicología',
    Servicios: 'Servicios',
    Otros: 'Otros',

}

export const cargosContext = {
  // Provincia
  gobiernoProvincial: { cargos: cargosGobiernoProvincial, usuario: "Hermana", cargoServicio: "Servicio" },
  oficiosProvinciales: { cargos: cargosOficiosProvinciales, usuario: "Hermana", cargoServicio: "Servicio" },
  otrosServiciosProvinciales: { cargos: cargosOtrosServiciosProvinciales, usuario: "Usuario", cargoServicio: "Servicio" },
  // Dirección general
  gobiernoGeneral: { cargos: cargosGobiernoGeneral, usuario: "Hermana", cargoServicio: "Servicio" },
  oficiosGenerales: { cargos: cargosOficiosGenerales, usuario: "Hermana", cargoServicio: "Servicio" },
  otrosServiciosGenerales: { cargos: cargosOtrosServiciosGenerales, usuario: "Usuario", cargoServicio: "Servicio" },
  // Representantes legales
  rlProvincial: { cargos: "rl", usuario: "Hermana", cargoServicio: "Representante legal" },
  rlGeneral: { cargos: "rl", usuario: "Hermana", cargoServicio: "Representante legal" },
  rlObra: { cargos: "rl", usuario: "Usuario", cargoServicio: "Representante legal" },
  // Equipos/Comisiones
  equiposComisiones: { cargos: cargosEquiposComisiones, usuario: "Usuario", cargoServicio: "Servicio" },
  // Comunidad
  serviciosComunitarios: { cargos: cargosServiciosComunitarios, entidad: "Comunidad", usuario: "Hermana", cargoServicio: "Servicio" },
  // Misiones equipos directivos
  equiposDirectivosEducativo: { cargos: cargosEquiposDirectivosEducativo, entidad: "Misión", usuario: "Usuario", cargoServicio: "Cargo" },
  equiposDirectivosAlojamiento: { cargos: cargosEquiposDirectivosAlojamiento, entidad: "Misión", usuario: "Usuario", cargoServicio: "Cargo" },
  equiposDirectivosSalud: { cargos: cargosEquiposDirectivosSalud, entidad: "Misión", usuario: "Usuario", cargoServicio: "Cargo" },
  equiposDirectivosEspiritualidad: { cargos: cargosEquiposDirectivosEspiritualidad, entidad: "Misión", usuario: "Usuario", cargoServicio: "Cargo" },
  equiposDirectivosSocial: { cargos: cargosEquiposDirectivosSocial, entidad: "Misión", usuario: "Usuario", cargoServicio: "Cargo" },
  //112022 para añadir hermanas que trabajan en la obra
  hermanasQueTrabajanObraOProyecto: { cargos: cargosHermanasQueTrabajanObraOProyecto, entidad: "Misión", usuario: "Usuario", cargoServicio: "Cargo" },
};

//042022 para destinos
export const destinosContext = {
  //destinos comunitarios
  //hermanasComunidad: { cargos: destinosComunidad, usuario: "Hermana", cargoServicio: "Servicio" },

}

// Para el filtro en servicios vida religiosa
export const tipoCargosContext = {
  // Dirección general
  GG: "Gobierno general",
  OG: "Oficios generales",
  OSG: "Otros servicios generales",
  RLG: "Representantes legales generales",
  // Provincial
  GP: "Gobierno provincial",
  OP: "Oficios provinciales",
  OSP: "Otros servicios provinciales",
  RLP: "Representantes legales provinciales",
  // Comunitarios
  SC: "Servicios comunitarios",
  // Equipos
  ECP: "Equipos/Comisiones provinciales",
  ECG: "Equipos/Comisiones generales",
  // Obras mision cargos
  EDO: "Equipos directivos",
};

// ********************************************************* DOCUMENTOS ************************************************
export const tiposDocumentos = {
  Convenio: "Convenio",
  Otros: "Otros",
};
